/**
 * API utility functions for HTTP communication.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Returns standard headers for API requests.
 * Includes cache control headers to prevent stale data.
 */
export var getHeaders = function (additionalHeaders) {
    if (additionalHeaders === void 0) { additionalHeaders = {}; }
    return (__assign({ "Content-Type": "application/json", "Cache-Control": "no-cache, no-store, must-revalidate", Pragma: "no-cache", Expires: "0" }, additionalHeaders));
};
/**
 * Escapes special characters in CQL query values.
 * CQL (Contextual Query Language) is used by FOLIO for searching.
 * Special chars: " \ * ? ^ ( )
 */
export var escapeCql = function (value) {
    return value.replace(/["\\*?^()]/g, "\\$&");
};
/**
 * Builds URLSearchParams from AuditLogFilterParams, mapping camelCase to snake_case.
 * Shared between fetchAuditLogs and fetchAuditLogExport.
 */
export var buildAuditLogSearchParams = function (params) {
    var searchParams = new URLSearchParams();
    var paramMap = {
        action_type: params.actionType,
        entity_type: params.entityType,
        user_id: params.userId,
        related_to: params.relatedTo,
        date_from: params.dateFrom,
        date_to: params.dateTo,
        q: params.q,
    };
    Object.entries(paramMap).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value !== undefined && value !== "")
            searchParams.set(key, value);
    });
    return searchParams;
};
